import React, { useEffect, useState } from 'react'
import { Collapse } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import leftarrow from '../../../../assets/images/left-arrow.svg'
import { currencyConvertor, isEclipseOpsTruck, setControlNumber } from '../../../../Utils/Utility';
import { upperFirst } from 'lodash';
import EmailDialoge from './EmailDialoge';
import { clearSendReceipt } from "@mobile-dev/platform/common/redux/actions/CommonAction";
import { injectIntl } from 'react-intl';
import CompletedDetailsDialogue from './CompletedDetailsDialogue';
import { diffInDays, getCurrentDate, getFormattedDate } from '../../../Common/DateUtils';
import moment from 'moment';

function CompletedDetails({ intl, ...props }) {
    const id = props.match.params.id;
    const completedData = useSelector(state => state.completed.completedPo);
    const load = completedData.loads.find(load => load.load_id === id);
    const [showText, setShowText] = useState(false);
    const [isSendEmail, setIsSendEmail] = useState(false);
    const [isReceiptButtonDisabled, setReceiptButtonDisabled] = useState(false);
    const { formatMessage } = intl;
    const [downloadReceiptText, setdownloadReceiptText] = useState(formatMessage({ id: "app.download_receipt" }));
    const [shareReceiptText, setShareReceiptText] = useState(formatMessage({ id: "app.share_receipt" }));
    const [shareReceiptDialoge, setShareReceiptDialoge] = useState(false);
    const [shareReceiptHeaderText, setShareReceiptHeaderText] = useState('')
    const [loadCompletedTimeInDays, setloadCompletedTimeInDays] = useState()
    const loadExpiryTime = 15
    const dispatch = useDispatch();
    let controlNumber = load.load_control_num;

    /* Check if amount is uncollected or not */
    const isUcollected = load.total_bill_amount === load.total_paid ? false : true
    const uncollected_amount = currencyConvertor(load.total_bill_amount - load.total_paid)

    if (controlNumber) {
        setControlNumber(controlNumber);
    }
    useEffect(() => {
        if (!load.receipt_url || load.receipt_url === '') {
            setdownloadReceiptText(formatMessage({ id: "app.download_receipt_pending" }))
            setShareReceiptText(formatMessage({ id: "app.share_receipt_pending" }))
            setReceiptButtonDisabled(true)
        } else {
            setdownloadReceiptText(formatMessage({ id: "app.download_receipt" }))
            setShareReceiptText(formatMessage({ id: "app.share_receipt" }))
            setReceiptButtonDisabled(false)
        }
    }, [load.receipt_url, intl.locale]);

    useEffect(() => {
        if (load) {
            setloadCompletedTimeInDays(diffInDays(moment(load.unload_end_time), getCurrentDate()))
        }
    }, [load])

    const handleCollapse = () => {
        setShowText(!showText);
    }

    const closeModal = () => {
        setIsSendEmail(false);
        setShareReceiptDialoge(false)
        dispatch(clearSendReceipt());
    }

    const handleShareReceiptEmailClick = () => {
        if (isReceiptButtonDisabled) {
            setShareReceiptHeaderText(formatMessage({ id: "app.share_receipt_pending" }))
            setShareReceiptDialoge(true);
            return
        }
        setIsSendEmail(true);
    }

    const downloadReceiptClickHandler = () => {
        if (isReceiptButtonDisabled) {
            setShareReceiptHeaderText(formatMessage({ id: "app.download_receipt_pending" }))
            setShareReceiptDialoge(true);
            return
        }
        window.open(load.receipt_url, "_blank")
    }

    const shouldShowReceipt = () => {
        if (isEclipseOpsTruck(load)) {
            return true
        } else {
            return loadCompletedTimeInDays < loadExpiryTime
        }
    }

    return (

        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <div className="top_header_bar">
                            <div className="row mobile-row">
                                <div className="col-sm col-xl-4 d-flex align-items-center p-0">
                                    <Link to='/' className="text-dark" style={{ marginRight: '15px' }}>
                                        <img src={leftarrow} className="bakc-arrow" />
                                    </Link>
                                    <h3 className="m-0 h3-heading" title={formatMessage({ id: "app.control_number" })}> {load.load_control_num}
                                        <br />
                                        {!isUcollected ? <label className="header-subtitle" title={formatMessage({ id: "app.completed_header" })}>{formatMessage({ id: "app.completed_header" })}</label> :
                                            <label className="header-subtitle" title={formatMessage({ id: "app.payment_uncollected" })}> {`$${uncollected_amount} ${formatMessage({ id: "app.payment_uncollected" })}`}</label>
                                        }
                                    </h3>
                                </div>
                                {
                                    shouldShowReceipt() &&
                                    <div className='col-sm-6 col-xl-8 d-flex  justify-content-end'>
                                        <div className="align-items-center header-btn-block">
                                            <button className={!isReceiptButtonDisabled ? `btn btn-chartreuse justify-content-center min-width mr-2 share-receiptBtn` : `btn btn-chartreuse justify-content-center min-width mr-2 share-receiptBtn pending`} onClick={handleShareReceiptEmailClick}>
                                                <i className="fal fa-envelope fa-fw"></i>
                                                <span>{shareReceiptText}</span>
                                            </button>
                                        </div>

                                        <div className="align-items-center header-btn-block">
                                            <button className={!isReceiptButtonDisabled ? `btn btn-chartreuse justify-content-center min-width mr-2 download-receiptBtn` : `btn btn-chartreuse justify-content-center min-width mr-2 download-receiptBtn pending`} onClick={downloadReceiptClickHandler}>
                                                <i className="fal fa-arrow-to-bottom fa-fw"></i>
                                                <span>
                                                    {downloadReceiptText}
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>

                        <div className="container_block" style={{ padding: '40px' }}>
                            <div className="row">
                                <div className="col-sm-4 col-xxl-4">
                                    <section>
                                        <div className="row">
                                            <div className="form-group col-sm-12  tbl">
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.total_charges" })}</b></td>
                                                            {
                                                                isEclipseOpsTruck(load)
                                                                    ? <td className="text-danger"><b>${currencyConvertor(parseFloat(parseFloat(load.total_bill_amount) + parseFloat(load.serviceFee)).toFixed(2))}</b></td>
                                                                    : <td className="text-danger"><b>${currencyConvertor(load.total_bill_amount)}</b></td>
                                                            }

                                                        </tr>
                                                        {/* {
                                                            isEclipseOpsTruck(load)
                                                                ? <tr>
                                                                    <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.bill_amount" })}</b></td>
                                                                    <td className="text-danger"><b>${currencyConvertor(load.total_bill_amount)}</b></td>
                                                                </tr>
                                                                : <tr>
                                                                    <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.total_charges" })}</b></td>
                                                                    <td className="text-danger"><b>${currencyConvertor(load.total_bill_amount)}</b></td>
                                                                </tr>
                                                        } */}

                                                        {/* {
                                                            isEclipseOpsTruck(load) &&

                                                            <tr>
                                                                <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.service_fee" })}</b></td>
                                                                <td className="text-danger"><b>${currencyConvertor(serviceFee)}</b></td>
                                                            </tr>

                                                        } */}

                                                        {/* {
                                                            isEclipseOpsTruck(load) &&
                                                            <tr>
                                                                <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.total_charges" })}</b></td>
                                                                <td className="text-danger"><b>${currencyConvertor(load.total_paid)}</b></td>
                                                            </tr>
                                                        } */}

                                                        {isUcollected && <tr>
                                                            <td className="col-9 p-0 text-danger"><b>{formatMessage({ id: "app.payment_uncollected", id1: "app.amount" })} Amount</b></td>
                                                            <td className="text-danger"><b>${uncollected_amount}</b></td>
                                                        </tr>}
                                                        {
                                                            !isEclipseOpsTruck(load) &&
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan='3'><b><h4 className="mb-2 mt-2 txtwhite">{formatMessage({ id: "app.itemized_charges" })}</h4></b>

                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="col-9 p-0">{formatMessage({ id: "app.unloading" })}</td>
                                                                    <td>${currencyConvertor(load.unloading_bill_amount)}</td>
                                                                </tr>
                                                            </tbody>
                                                        }

                                                        {load.fees && load.fees.map((fee, index) => {

                                                            return (
                                                                <>
                                                                    {fee.fee_amount &&
                                                                        <tr>

                                                                            <td className="col-9 p-0" key={index}>{fee.fee_type}</td>
                                                                            <td>${currencyConvertor(fee.fee_amount)}</td>

                                                                        </tr>
                                                                    }
                                                                </>
                                                            )

                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>

                                </div>
                                <div className="col-sm-5 col-xxl-4">
                                    <section>
                                        <div className="row">
                                            <div className="form-group col-sm-12 tbl">
                                                <table>
                                                    <tbody>
                                                        {
                                                            !isEclipseOpsTruck(load) &&
                                                            <tbody>
                                                                <tr>
                                                                    <td colspan="2"><h4 className="mb-2 txtwhite">{formatMessage({ id: "app.labor_details" })} :</h4></td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="col-7 p-0">{formatMessage({ id: "app.unloading_started" })} :</td>
                                                                    <td>{getFormattedDate(load?.unload_start_time)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="col-7 p-0">{formatMessage({ id: "app.unloading_ended" })} : </td>
                                                                    <td>{getFormattedDate(load?.unload_end_time)}</td>
                                                                </tr>
                                                            </tbody>
                                                        }

                                                        <tr>
                                                            <td colspan="2"><h4 className="mt-2 mb-2 txtwhite">{formatMessage({ id: "app.load_labor_type" })}: </h4></td>
                                                        </tr>
                                                        <tr>
                                                            <td className="col-7 p-0">{upperFirst(load?.load_type.toLowerCase())}/{upperFirst(load?.labor_type.toLowerCase())}</td>

                                                        </tr>
                                                        {load?.start_pallets && load?.end_pallets &&
                                                            <tr>
                                                                <td className="col-7 p-0">{formatMessage({ id: "app.start_end_pallets" })}</td>
                                                                <td>{load?.start_pallets}/{load?.end_pallets}</td>
                                                            </tr>
                                                        }
                                                        {load?.special_circumstances && load?.special_circumstances[0].name &&
                                                            <>
                                                                <tr>
                                                                    <td colspan="2"><h4 className="mt-2 mb-2 txtwhite">{formatMessage({ id: "app.special_circumstances" })}</h4></td>
                                                                </tr>

                                                                {load.special_circumstances.map((spc, index) => {
                                                                    return (
                                                                        <tr>
                                                                            <td key={index}>{upperFirst(spc?.name.toLowerCase())}</td>
                                                                            <td>{spc.units && `${spc?.units} ${upperFirst(spc?.unit_type.toLowerCase())}`}</td>
                                                                        </tr>
                                                                    )
                                                                })}

                                                            </>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div className="col-sm-3 col-xxl-4">
                                    <div className="row">
                                        <div className="form-group col-sm-6">

                                            <h4 className="mb-2 txtwhite">{formatMessage({ id: "app.po" })}</h4>


                                            {!showText ?
                                                <>
                                                    {load.pos.slice(0, 4).map((po, index) => {
                                                        return (
                                                            <p key={index}>{po.po_number}</p>
                                                        )
                                                    })}
                                                    {load.pos.length > 4 &&
                                                        < a href="javascript:void(0);" onClick={handleCollapse} > {formatMessage({ id: "app.see_more" })}</a>
                                                    }
                                                </>
                                                :
                                                <>

                                                    <Collapse in={showText}>
                                                        <div>
                                                            {load.pos.map((po, index) => {
                                                                return (
                                                                    <p key={index}>{po.po_number}</p>
                                                                )
                                                            })}
                                                        </div>
                                                    </Collapse>
                                                    {load.pos.length > 4 &&
                                                        < a href="javascript:void(0);" onClick={handleCollapse} >{formatMessage({ id: "app.see_less" })}</a>
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>

                    </div>
                    {isSendEmail &&
                        <EmailDialoge
                            open
                            id={id}
                            loadId={load.load_id}
                            onClose={closeModal} />}
                    {shareReceiptDialoge &&
                        <CompletedDetailsDialogue
                            id={id}
                            loadId={load.load_id}
                            shareReceiptHeaderText={shareReceiptHeaderText}
                            onClose={closeModal}
                        />}
                </div>

            </div>
        </div>
    )
}

export default injectIntl(CompletedDetails);
